import { InjectionToken } from '@angular/core'

export const API_URL: InjectionToken<string> = new InjectionToken<string>('apiUrl')
